import React from 'react';
import { Button } from 'react-bootstrap';

/**
 * Tlačítko „Výchozí šířky" k tabulce s nastavitelnými sloupci.
 *
 * Ukáže se, až když si uživatel šířky opravdu nastavil — dokud jsou výchozí,
 * nemá co vracet a v liště by jen překáželo.
 */
export default function ColumnWidthsReset({ maUlozene, vychozi, className = '' }) {
  if (!maUlozene) return null;

  return (
    <Button
      variant="outline-secondary"
      size="sm"
      className={className}
      title="Vrátit šířky sloupců na výchozí"
      onClick={vychozi}
    >
      <i className="bi bi-arrows-angle-contract"></i>
    </Button>
  );
}
